import {
  type GuestTypeImage,
  type GuestPassionImage,
  type SpaceFeatureIcons,
  type SpaceFilter,
  FilterType,
} from "modules/spaces/domain/space/space.types";
import { ReactComponent as NightOwlsImage } from "../../ui/assets/images/night-owls.svg";
import { ReactComponent as EarlyBirdsImage } from "../../ui/assets/images/early-birds.svg";
import { ReactComponent as GlobeTrottersImage } from "../../ui/assets/images/globe-trotters.svg";
import { ReactComponent as VeggieImage } from "../../ui/assets/images/veggie.svg";
import { ReactComponent as MusicianImage } from "../../ui/assets/images/musician.svg";

export const SPACE_FEATURE_ICONS: SpaceFeatureIcons = {
  "shared-bathroom": "bath",
};

export const GUEST_TYPE_IMAGES: GuestTypeImage = {
  "night-owls": <NightOwlsImage />,
  "early-birds": <EarlyBirdsImage />,
};

export const GUEST_INTEREST_IMAGES: GuestPassionImage = {
  "globe-trotters": <GlobeTrottersImage />,
  musician: <MusicianImage />,
  veggie: <VeggieImage />,
};

export const SPACE_FILTERS_DEFAULT: SpaceFilter[] = [
  {
    name: "accommodation",
    options: ["single", "studio"],
    type: FilterType.Checkbox,
    isMultiChoice: false,
  },
  {
    name: "  bathroom",
    options: ["private-bathroom"],
    type: FilterType.Toggle,
    isMultiChoice: false,
  },
  {
    name: "housemates",
    options: ["any", "many", "more"],
    type: FilterType.Radio,
    isMultiChoice: false,
  },
  {
    name: "floor",
    options: ["any", "0", "1", "2", "3", "4", "5"],
    type: FilterType.Radio,
    isMultiChoice: true,
  },
];
